export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/prize-star-8126eafc769affb25cd31e9bc385c029.svg";